import Icon from 'helpers/svg-icon';
import { mainTextColor } from 'constants/variables';

const PlayIcon = ({
  width = 18,
  height = 22.922,
  fillColor = mainTextColor,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 18 22.922" {...rest}>
    <path
      id="play_arrow_FILL1_wght700_GRAD0_opsz48"
      d="M295-786.078V-809l18,11.461Z"
      transform="translate(-295 809)"
      fill={fillColor}
    />
  </Icon>
);

const PauseIcon = ({
  width = 18,
  height = 19.44,
  fillColor = mainTextColor,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 18 19.114" {...rest}>
    <path
      id="pause_FILL1_wght700_GRAD0_opsz48"
      d="M183.847-786.886V-806H191v19.114Zm-10.847,0V-806h7.153v19.114Z"
      transform="translate(-173 806)"
      fill={fillColor}
    />
  </Icon>
);

export { PlayIcon, PauseIcon };
